import * as React from "react";
import { forwardRef } from "react";
const SvgView = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M.072 8.372a1 1 0 0 1 0-.743C.162 7.4 2.382 2 7.979 2s7.82 5.4 7.908 5.629a1 1 0 0 1 0 .743C15.8 8.6 13.577 14 7.979 14S.163 8.6.072 8.372M2.1 8c.54 1.066 2.344 4 5.88 4 3.519 0 5.343-2.947 5.883-4-.54-1.064-2.343-4-5.882-4C4.46 4 2.637 6.948 2.1 8m2.892 0a2.99 2.99 0 1 1 5.98.02A2.99 2.99 0 0 1 4.991 8" }));
const ForwardRef = forwardRef(SvgView);
export { ForwardRef as ReactComponent };
